import { render, staticRenderFns } from "./DetalleCitaRegistrada.vue?vue&type=template&id=58ad1170&"
import script from "./DetalleCitaRegistrada.vue?vue&type=script&lang=js&"
export * from "./DetalleCitaRegistrada.vue?vue&type=script&lang=js&"
import style0 from "./DetalleCitaRegistrada.vue?vue&type=style&index=0&id=58ad1170&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports